<template lang="pug">
.PersonalAccountNavigationComponent
  .items
    template(v-for="(item, index) in items")
      .item
        personal-account-navigation-item(
          :item="item",
          :key="index"
        )
</template>

<script>
import PersonalAccountNavigationItem from './PersonalAccountNavigationItem'

export default {
  components: {
    PersonalAccountNavigationItem
  },
  inject: ['store'],
  computed: {
    items () {
      const items = []
      if (this.store.user.profile.hasChildren) {
        items.push({
          label: 'Домашние задания',
          route: {
            name: 'BooksProgress'
          }
        })
      }

      items.push(
        {
          label: 'Подготовка к ВПР',
          route: {
            name: 'VprProgress'
          }
        },
        {
          label: 'Профиль',
          route: {
            name: 'Profile'
          }
        }
      )
      return items
    }
  }
}
</script>

<style lang="sass" scoped>
.PersonalAccountNavigationComponent
  margin: 0 0 12*$u 0
  @media (max-width: $padWidth)
    margin: 0 -#{$appSidePaddingDesktop}
    padding-bottom: 7*$u
    display: flex
    @include invisible-scrollbar

  .items
    display: flex
    flex-flow: row nowrap
    @include gap(7.5*$u)
    @media (max-width: $padWidth)
      padding: 0 $appSidePaddingDesktop
      @include gap(3*$u)
</style>
